// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__34ZFM","colMaxWidth":"Table_colMaxWidth__2WtRh"};